module.exports = {"id":"215914","name":"N'Golo Kanté","rating":"88","photo":"./data/images/photos/0/215914.png","club":{"name":"Chelsea","logo":"./data/images/clubs/Chelsea.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/N'GoloKante0.json
// module id = 3110
// module chunks = 0